var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg13(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "232.83mm",
    height: "141.36mm",
    viewBox: "0 0 232.83 141.36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8931"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33 2.4414e-4h637.5v535.5h-637.5z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8941"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8955"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4305e-5 0h960v540h-960z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8971"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8981"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8991"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540l-960 1.2207e-4",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9001"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540l-960 1.2207e-4",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9011"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9021"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9041"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9051"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9061"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m94.5 193.5h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9071"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9083"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m141 189.75h90.75v90.75h-90.75z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9093"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m206.25 197.25h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9127"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m250.5 191.25h108v108h-108z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9137"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9149"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m331.5 191.25h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9171"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m48.75 191.25h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9181"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9193"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m377.25 189.75h90.75v90.75h-90.75z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9203"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9223"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m185.25 243h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9233"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9245"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m325.5 246.75h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9255"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-556.38 -408.88)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 546.55 558.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.857 23.571h660v400.71h-660z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8931)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.8542,0,-4.7e-8,8.8646,33,-102.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8941)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.884 28.858c-3.314 0-6-2.686-6-6 0-3.313 2.686-6 6-6s6 2.687 6 6c-4e-3 3.312-2.688 5.996-6 6zm0-10.5c-2.485 0-4.5 2.015-4.5 4.5 0 2.486 2.015 4.5 4.5 4.5s4.5-2.014 4.5-4.5c-2e-3 -2.485-2.015-4.499-4.5-4.503z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.184 35.761-3.975 3c-0.521 0.388-0.892 0.944-1.05 1.575l-1.5 5.175c-0.764 2.559-3.104 4.325-5.775 4.355h-7.5v4.5h-45v-31.509h6c-2e-4 0.504 0.05 1.006 0.15 1.5h-4.65v9.799h42v-9.799h-22.65c0.1-0.494 0.151-0.996 0.15-1.5h24.75c0 0.504 0.05 1.006 0.15 1.5h-0.9v24.009h3v-10.46h11.535c0.126-0.126 0.261-0.244 0.403-0.352l3.943-2.977c0.386-0.286 0.615-0.736 0.619-1.217v-7.5c0-0.828-0.672-1.5-1.5-1.5h-2.4c0.1-0.494 0.151-0.996 0.15-1.5h2.25c1.655 5e-3 2.995 1.345 3 3v7.5c-3e-3 0.944-0.447 1.832-1.2 2.401zm-21.3-0.105h-42v17.21h42zm6 12.71h3c2-0.035 3.751-1.355 4.335-3.269l1.493-5.152c0.051-0.183 0.114-0.363 0.189-0.538h-9.017z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.634 28.858c-3.314 0-6-2.686-6-6 0-3.313 2.686-6 6-6s6 2.687 6 6c-4e-3 3.312-2.688 5.996-6 6zm0-10.5c-2.485 0-4.5 2.015-4.5 4.5 0 2.486 2.015 4.5 4.5 4.5s4.5-2.014 4.5-4.5c-2e-3 -2.485-2.015-4.499-4.5-4.503z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8955)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,-1,7.2,495.55)",
    fill: "#000000",
    fontFamily: "TimesNewRomanPSMT",
    fontSize: "36.05px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 26.2444 38.24905 47.2976 64.565552 80.355453 90.846001 106.6359 116.3694 126.13895 138.1436 156.16859 171.9585 189.22646 198.95995 208.72951 225.99745 236.48801 254.513 270.30289 279.3154 288.32791 305.59586 321.38574 333.39041 345.39505 363.42004 379.20996 394.99985 412.26779 428.05771 446.0827 461.87259 476.11234 486.60291 498.60754 522.65289",
    y: 0
  }, "Drive a truck to deliver packages (R)"))), /*#__PURE__*/React.createElement("path", {
    d: "m503.63 259.12c0 18.23 14.6 33 32.62 33s32.63-14.77 32.63-33c0-18.22-14.61-33-32.63-33s-32.62 14.78-32.62 33z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.63 259.12c0 18.23 14.6 33 32.62 33s32.63-14.77 32.63-33c0-18.22-14.61-33-32.63-33s-32.62 14.78-32.62 33z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m508.9 278.58 14.71 37.03 28.69-27.66z",
    fill: "#4472c4",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m508.9 278.58 14.71 37.03 28.69-27.66z",
    fill: "none",
    stroke: "#2f528f",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m521.12 238.78-7.11-12.22c-3.93-6.75-10.44-10.29-14.55-7.9-4.1 2.39-4.24 9.79-0.32 16.55l7.12 12.22z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m521.12 238.78-7.11-12.22c-3.93-6.75-10.44-10.29-14.55-7.9-4.1 2.39-4.24 9.79-0.32 16.55l7.12 12.22z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m552.98 253.09 16.43 10.59c9.07 5.85 19.01 6.59 22.2 1.64 3.19-4.94-1.59-13.69-10.66-19.54l-16.43-10.59z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m552.98 253.09 16.43 10.59c9.07 5.85 19.01 6.59 22.2 1.64 3.19-4.94-1.59-13.69-10.66-19.54l-16.43-10.59z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "m523.13 259.5c0 5.59 3.69 10.12 8.25 10.12 4.55 0 8.25-4.53 8.25-10.12s-3.7-10.13-8.25-10.13c-4.56 0-8.25 4.54-8.25 10.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m523.13 259.5c0 5.59 3.69 10.12 8.25 10.12 4.55 0 8.25-4.53 8.25-10.12s-3.7-10.13-8.25-10.13c-4.56 0-8.25 4.54-8.25 10.13z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m536.25 264.75c0 5.38 3.69 9.75 8.25 9.75s8.25-4.37 8.25-9.75-3.69-9.75-8.25-9.75-8.25 4.37-8.25 9.75z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m534.84 259.31c0-1.08-0.88-1.95-1.95-1.95-1.08 0-1.95 0.87-1.95 1.95s0.87 1.95 1.95 1.95c1.07 0 1.95-0.87 1.95-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m548.13 264.04c0-1.07-0.87-1.94-1.95-1.94-1.07 0-1.95 0.87-1.95 1.94 0 1.08 0.88 1.95 1.95 1.95 1.08 0 1.95-0.87 1.95-1.95z",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.23 252.69c1.26-3.84-2.76-8.62-8.99-10.67s-12.3-0.59-13.57 3.25l3.48 1.15c0.64-1.92 4.64-2.33 8.94-0.92 4.31 1.42 7.29 4.13 6.66 6.05z",
    fill: "#ffffff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.23 252.69c1.26-3.84-2.76-8.62-8.99-10.67s-12.3-0.59-13.57 3.25l3.48 1.15c0.64-1.92 4.64-2.33 8.94-0.92 4.31 1.42 7.29 4.13 6.66 6.05z",
    fill: "none",
    stroke: "#a5a5a5",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9061)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.5,193.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9071)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.134 65.87-25.5-15.454v-28.596l25.5-15.454 25.5 15.454v28.596zm23.303-15.877-10.741-6.51-23.303 14.124 10.741 6.509zm-23.303-14.123-23.303 14.123 11.115 6.737 23.304-14.123zm-24 12.792 23.25-14.092v-25.995l-23.25 14.091zm24.75-40.087v25.995l23.25 14.092v-25.996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.612 33.28-0.728-0.439v-6.499l2.272 1.363 3.75 2.25 0.728 0.439v6.497l-2.272-1.363zm4.522-2.037-3.75-2.25v3l3.75 2.25z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9083)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2604,-1.88e-7,-1.88e-7,1.2604,141,189.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9093)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.134 65.87-25.5-15.454v-28.596l25.5-15.454 25.5 15.454v28.596zm23.303-15.877-10.741-6.51-23.303 14.124 10.741 6.509zm-23.303-14.123-23.303 14.123 11.115 6.737 23.304-14.123zm-24 12.792 23.25-14.092v-25.995l-23.25 14.091zm24.75-40.087v25.995l23.25 14.092v-25.996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.612 33.28-0.728-0.439v-6.499l2.272 1.363 3.75 2.25 0.728 0.439v6.497l-2.272-1.363zm4.522-2.037-3.75-2.25v3l3.75 2.25z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9105)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(206.25,197.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9115)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.134 65.87-25.5-15.454v-28.596l25.5-15.454 25.5 15.454v28.596zm23.303-15.877-10.741-6.51-23.303 14.124 10.741 6.509zm-23.303-14.123-23.303 14.123 11.115 6.737 23.304-14.123zm-24 12.792 23.25-14.092v-25.995l-23.25 14.091zm24.75-40.087v25.995l23.25 14.092v-25.996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.612 33.28-0.728-0.439v-6.499l2.272 1.363 3.75 2.25 0.728 0.439v6.497l-2.272-1.363zm4.522-2.037-3.75-2.25v3l3.75 2.25z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9127)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5,-1.88e-7,-3.77e-7,1.5,250.5,191.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9137)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.134 65.87-25.5-15.454v-28.596l25.5-15.454 25.5 15.454v28.596zm23.303-15.877-10.741-6.51-23.303 14.124 10.741 6.509zm-23.303-14.123-23.303 14.123 11.115 6.737 23.304-14.123zm-24 12.792 23.25-14.092v-25.995l-23.25 14.091zm24.75-40.087v25.995l23.25 14.092v-25.996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.612 33.28-0.728-0.439v-6.499l2.272 1.363 3.75 2.25 0.728 0.439v6.497l-2.272-1.363zm4.522-2.037-3.75-2.25v3l3.75 2.25z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9149)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(331.5,191.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9159)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.134 65.87-25.5-15.454v-28.596l25.5-15.454 25.5 15.454v28.596zm23.303-15.877-10.741-6.51-23.303 14.124 10.741 6.509zm-23.303-14.123-23.303 14.123 11.115 6.737 23.304-14.123zm-24 12.792 23.25-14.092v-25.995l-23.25 14.091zm24.75-40.087v25.995l23.25 14.092v-25.996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.612 33.28-0.728-0.439v-6.499l2.272 1.363 3.75 2.25 0.728 0.439v6.497l-2.272-1.363zm4.522-2.037-3.75-2.25v3l3.75 2.25z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9171)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.75,191.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9181)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.134 65.87-25.5-15.454v-28.596l25.5-15.454 25.5 15.454v28.596zm23.303-15.877-10.741-6.51-23.303 14.124 10.741 6.509zm-23.303-14.123-23.303 14.123 11.115 6.737 23.304-14.123zm-24 12.792 23.25-14.092v-25.995l-23.25 14.091zm24.75-40.087v25.995l23.25 14.092v-25.996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.612 33.28-0.728-0.439v-6.499l2.272 1.363 3.75 2.25 0.728 0.439v6.497l-2.272-1.363zm4.522-2.037-3.75-2.25v3l3.75 2.25z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9193)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2604,-1.88e-7,-3.77e-7,1.2604,377.25,189.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9203)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.134 65.87-25.5-15.454v-28.596l25.5-15.454 25.5 15.454v28.596zm23.303-15.877-10.741-6.51-23.303 14.124 10.741 6.509zm-23.303-14.123-23.303 14.123 11.115 6.737 23.304-14.123zm-24 12.792 23.25-14.092v-25.995l-23.25 14.091zm24.75-40.087v25.995l23.25 14.092v-25.996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.612 33.28-0.728-0.439v-6.499l2.272 1.363 3.75 2.25 0.728 0.439v6.497l-2.272-1.363zm4.522-2.037-3.75-2.25v3l3.75 2.25z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m531.18 262.65v-3.12l1 1.71-0.25-0.14c-0.41-0.23-0.72-0.59-0.88-1.02l-0.09-0.23 0.88 1.02-0.25-0.14c-0.62-0.35-1.01-1-1.01-1.71v-0.22c0-0.45 0.15-0.87 0.43-1.22l0.11-0.14 0.15-0.16 0.11-0.12c0.37-0.36 0.86-0.57 1.38-0.57h0.25c1.08 0 1.95 0.88 1.95 1.95 0 1.08-0.87 1.95-1.95 1.95h-0.25l1.38-0.57-0.12 0.11 0.15-0.16-0.12 0.14 0.43-1.21v0.22l-1-1.7 0.25 0.14c0.41 0.23 0.72 0.59 0.88 1.02l0.09 0.23-0.88-1.02 0.25 0.14c0.62 0.34 1.01 1 1.01 1.7v3.12c0 1.08-0.88 1.95-1.95 1.95-1.08 0-1.95-0.87-1.95-1.95z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m546.51 267.01 0.14-0.26-0.08 0.16 0.12-0.26-0.17 0.79v-3.03c0-0.44 0.15-0.87 0.43-1.22l0.11-0.14-0.41 0.98 0.03-0.23c0.11-0.87 0.78-1.56 1.65-1.69l0.2-0.03-1.37 0.9 0.14-0.23c0.54-0.86 1.65-1.16 2.55-0.69s1.29 1.55 0.89 2.49c-0.39 0.93-1.44 1.41-2.41 1.09l-0.08-0.03-0.15-0.06-0.2-0.09 0.77 0.16h-4.54l0.5-0.06-0.42 0.11-0.29 0.05-0.25 0.03 0.5-0.13-0.28 0.12 0.07-0.03-0.26 0.11 0.59-0.4-0.14 0.14 0.32-0.43-0.14 0.25 0.25-0.94v0.25l-0.43-1.21 0.11 0.14-0.51-0.46 0.14 0.09 0.21 0.15 0.14 0.11-0.97-0.41 0.22 0.03c0.36 0.04 0.7 0.19 0.98 0.41l0.14 0.11-1.22-0.42h0.26c0.27 0 0.54 0.05 0.79 0.16l0.26 0.12-0.55-0.16 0.22 0.03c0.58 0.08 1.1 0.41 1.41 0.9l0.15 0.23-0.14-0.18 0.12 0.14 0.11 0.14c0.18 0.22 0.3 0.47 0.37 0.74l0.03 0.12-1.89-1.48h0.11c1.08 0 1.95 0.87 1.95 1.95s-0.87 1.95-1.95 1.95h-0.11c-0.9 0-1.68-0.61-1.89-1.48l-0.03-0.11 0.37 0.74-0.12-0.14-0.11-0.14-0.13-0.18-0.14-0.23 1.41 0.9-0.23-0.03c-0.19-0.02-0.37-0.07-0.55-0.15l-0.25-0.11 0.79 0.16h-0.26c-0.44 0-0.87-0.15-1.21-0.42l-0.14-0.12 0.97 0.42-0.23-0.03c-0.35-0.05-0.69-0.19-0.97-0.41l-0.14-0.12 0.21 0.15-0.14-0.08c-0.2-0.12-0.37-0.28-0.52-0.46l-0.11-0.14c-0.28-0.34-0.43-0.77-0.43-1.22v-0.25c0-0.33 0.08-0.66 0.25-0.95l0.14-0.25c0.09-0.16 0.19-0.31 0.32-0.43l0.14-0.15c0.17-0.17 0.37-0.3 0.59-0.4l0.26-0.11 0.06-0.03 0.29-0.11c0.16-0.07 0.33-0.11 0.51-0.13l0.25-0.03-0.29 0.05 0.43-0.11c0.16-0.04 0.33-0.07 0.5-0.07h4.54c0.26 0 0.52 0.06 0.76 0.16l0.2 0.09-0.15-0.06 0.09 0.03c0.56 0.19 1.01 0.62 1.21 1.19 0.21 0.56 0.14 1.18-0.18 1.69l-0.14 0.23c-0.3 0.48-0.81 0.81-1.38 0.89l-0.19 0.03 1.65-1.69-0.02 0.23c-0.05 0.36-0.19 0.69-0.42 0.98l-0.11 0.14 0.43-1.22v3.03c0 0.28-0.06 0.55-0.17 0.79l-0.11 0.26-0.08 0.15-0.14 0.26c-0.53 0.94-1.71 1.28-2.65 0.76-0.94-0.53-1.28-1.71-0.76-2.65z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m533.9 260.81c0-1.07-0.87-1.95-1.95-1.95-1.07 0-1.95 0.88-1.95 1.95 0 1.08 0.88 1.95 1.95 1.95 1.08 0 1.95-0.87 1.95-1.95z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m546.51 263.87c0-1.07-0.87-1.94-1.94-1.94-1.08 0-1.95 0.87-1.95 1.94 0 1.08 0.87 1.95 1.95 1.95 1.07 0 1.94-0.87 1.94-1.95z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9223)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(185.25,243)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9233)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.134 65.87-25.5-15.454v-28.596l25.5-15.454 25.5 15.454v28.596zm23.303-15.877-10.741-6.51-23.303 14.124 10.741 6.509zm-23.303-14.123-23.303 14.123 11.115 6.737 23.304-14.123zm-24 12.792 23.25-14.092v-25.995l-23.25 14.091zm24.75-40.087v25.995l23.25 14.092v-25.996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.612 33.28-0.728-0.439v-6.499l2.272 1.363 3.75 2.25 0.728 0.439v6.497l-2.272-1.363zm4.522-2.037-3.75-2.25v3l3.75 2.25z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9245)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(325.5,246.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9255)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.134 65.87-25.5-15.454v-28.596l25.5-15.454 25.5 15.454v28.596zm23.303-15.877-10.741-6.51-23.303 14.124 10.741 6.509zm-23.303-14.123-23.303 14.123 11.115 6.737 23.304-14.123zm-24 12.792 23.25-14.092v-25.995l-23.25 14.091zm24.75-40.087v25.995l23.25 14.092v-25.996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.612 33.28-0.728-0.439v-6.499l2.272 1.363 3.75 2.25 0.728 0.439v6.497l-2.272-1.363zm4.522-2.037-3.75-2.25v3l3.75 2.25z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg13);
export default __webpack_public_path__ + "static/media/13.873e51c3cba54806af1b6ebe6e7a8bf6.svg";
export { ForwardRef as ReactComponent };